import React from 'react'

const BenefitRequests = () => {
  return (
    <div>BenefitRequests</div>
  )
}

export default BenefitRequests